// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"d9e8e746efc57b6d","1034":"00f23c90c4a0e202","2942":"a03465d60902f1cd","8882":"a8968d904beb5c94"}[chunkId] + ".js";
};